import { createReducer } from '@reduxjs/toolkit';

import { setDefaultAutocompleteSuggestions } from 'Core/actions/autocomplete';
import { fromPayload } from 'Core/reducers/common';
import type { AutocompleteItem } from 'Models/index';

export default createReducer<AutocompleteItem[] | null>(null, (builder) =>
  builder.addCase(setDefaultAutocompleteSuggestions, fromPayload),
);
